/** F-148: common recurring governance duties. Choosing one fills the title and repeat cycle; every value can still be changed. No due date is assumed. */
export const obligationTemplates=[
  {type:'Annual general meeting',title:'Annual general meeting',cadenceMonths:12},
  {type:'Confirmation statement',title:'Confirmation statement',cadenceMonths:12},
  {type:'Annual accounts filing',title:'Annual accounts filing',cadenceMonths:12},
  {type:'Insurance renewal',title:'Insurance renewal',cadenceMonths:12},
  {type:'Quarterly board report',title:'Quarterly board report',cadenceMonths:3},
] as const;
export function obligationTemplate(type:string){return obligationTemplates.find(t=>t.type.toLowerCase()===type.trim().toLowerCase())}
